export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',

  // Products
  FULFILLMENT: '/products/fulfillment',
  INVENTORY: '/products/inventory',

  PRODUCTS_LIST: '/products/list',
  PRODUCT_REVIEW: '/products/product-detail/:id',
  PRODUCT_REVIEW_EDIT: '/products/product/edit/:id',

  //Promotions
  PROMOTIONS_LIST: '/products/promotions-list',
  PROMOTION_DETAIL: '/products/promotion-detail/:id',

  CREATE_PROMOTION: '/products/create-promotion/:promotionId?',
  SELECT_PROMOTION_TYPE: '/products/select-promotion-type',
  PROMOTION_REVIEW: '/products/promotion-review/:id',
  // Aliases
  PROMOTIONS_LIST_ALIAS: '/products/promotions-list',
  CREATE_PROMOTION_ALIAS: '/products/select-promotion-type',

  CREATE_PRODUCT_COMBINATION: '/products/create-product-combination',
  PRODUCT_COMBINATION_LIST: '/products/product-combination-list',
  PRODUCT_COMBO_DETAIL: '/products/combo-detail/:id',

  //Content
  PRODUCT_CATALOG: '/products/content/catalog',
  PROFILE_SEGMENTS_CREATE: '/profile/segments/create',
}
